import styled from 'styled-components'

import { RewardsCard } from '../../RewardsCard'

export const Card = styled(RewardsCard)`
  align-items: flex-start;
  gap: 16px;
  flex: 1;
  width: 100%;
`

export const Amount = styled.div`
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 0;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.brand.blue};
`

export const Divider = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool200};
  width: 100%;
`

export const EarningsContainer = styled.div`
  width: 100%;
`

export const EarningsHeader = styled.p`
  font-family: ${({ theme }) => theme.fonts.global.headers};
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const EarningsDetailsContainer = styled.div`
  width: 100%;
`

export const EarningsDetail = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  margin-bottom: 8px;
`

export const EarningDetailText = styled.p`
  margin-bottom: 0;
  width: 100%;
  text-align: left;
  font-family: ${({ theme }) => theme.fonts.global.body};
  font-size: 16px;
  font-weight: 400;
`

export const EarningDetailAmount = styled.p`
  margin-bottom: 0;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  font-size: 18px;
  font-weight: bold;
`

export const AchievementContainer = styled.div`
  display: flex;
  padding: 16px 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export const AchievementDetails = styled.div``

export const AchievementHeader = styled.p`
  font-family: ${({ theme }) => theme.fonts.global.body};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  margin-bottom: 8px;
`

export const AchievementText = styled.h2`
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 24px;
  text-align: left;
`
